import { gql } from "graphql-tag"

import vendor from "./vendor"

export default gql`
  ${vendor}

  fragment Store on Store {
    createdAt
    id
    isInternationalShipping
    isPublished
    publishedAt
    storeLocationIds
    updatedAt
    url
    vendor {
      ...Vendor
    }
  }
`
